<template>
  <div class="d-flex align-items-center flex-wrap gap-2">
    <div
      v-for="(item, index) in filters"
      :key="index"
    >
      <Component
        class="datatable-filter-item"
        :key="item.elastic_key"
        :is="defineComponent(item.type)"
        :extraArgs="extraArgs"
        v-bind="item"
        @change="onChange(item, $event)"
        @reset="onReset(item)"
      />
    </div>
  </div>
</template>

<script>
// Components
import FilterSelect from './FilterSelect'
import FilterSelectAggregate from './FilterSelectAggregate'
import FilterDate from './FilterDate'

export default {
  components: {
    FilterSelect,
    FilterSelectAggregate,
    FilterDate
  },
  props: {
    filters: {
      type: Array
    },
    slug: {
      type: String
    },
    search: {
      type: Object
    },
    filtersToApply: {
      type: Array
    },
    queryString: {
      type: String
    }
  },
  computed: {
    extraArgs () {
      return {
        slug: this.slug,
        search: this.search,
        filtersToApply: this.filtersToApply,
        queryString: this.queryString
      }
    }
  },
  methods: {
    defineComponent (type) {
      const components = {
        selector: 'FilterSelect',
        'date-range': 'FilterDate',
        'selector-aggregate': 'FilterSelectAggregate'
      }
      return components[type]
    },
    onChange (item, event) {
      item.pick = event
      const filters = this.filters.filter(el => el?.pick?.length)
      this.$emit('change', filters)
    },
    onReset (item) {
      item.pick = []
      const filters = this.filters.filter(el => el?.pick?.length)
      this.$emit('change', filters)
    }
  }
}
</script>
